import { render } from "./PrivateNetworking.vue?vue&type=template&id=2af725f1"
import script from "./PrivateNetworking.vue?vue&type=script&lang=js"
export * from "./PrivateNetworking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__